import type { ClosedReason } from '@prerender/diagnostics-api';

export const CLOSED_REASONS = [
  'closed_by_cs',
  'checked_by_prerender',
  'account_not_paying',
] as const satisfies readonly ClosedReason[];

export const CLOSED_REASON_LABELS: Record<ClosedReason, string> = {
  closed_by_cs: 'Closed by CS',
  checked_by_prerender: 'Closed — checked by Prerender',
  account_not_paying: 'Closed — account no longer paying',
};

export function closedReasonLabel(reason: ClosedReason): string {
  return CLOSED_REASON_LABELS[reason];
}
